"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setView = exports.INBOX_SET_VIEW = void 0;
var INBOX_SET_VIEW = "inbox/SET_VIEW";
exports.INBOX_SET_VIEW = INBOX_SET_VIEW;

var setView = function setView(view) {
  return {
    type: INBOX_SET_VIEW,
    payload: view
  };
};

exports.setView = setView;